/*
  Honeypot guard for the email-capture form.

  Both post as ordinary Shopify form submissions, so there is no server-side
  hook to reject a bot on. This blocks the submit when the hidden field comes
  back filled — a speed bump against blind form-fillers, not a defence against
  anything targeted, and it does nothing with JavaScript off. Shopify's own
  spam handling is what actually backstops these forms.

  Scoped to forms that carry a trap field. Today that is only the email capture —
  Dawn's stock contact form has no trap and is untouched by this.
*/
(function () {
  var TRAP = 'input[name="miles_hp"]';

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      var trap = form.querySelector(TRAP);
      if (!trap || trap.value.trim() === '') return;

      event.preventDefault();
    },
    // Capture phase: this has to run before any other submit handler decides
    // the form is going through.
    true
  );
})();
